var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 214,
    viewBox: "0 0 420 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.82 186.185C318.104 185.653 316.37 185.178 314.675 184.778C319.234 149.85 298.244 115.613 263.518 104.846C247.614 99.9146 231.332 100.651 216.848 105.905C211.102 79.5391 191.73 56.8705 164.098 48.3027C123.193 35.6196 79.771 58.5607 67.0543 99.5736C66.2539 102.155 65.568 104.772 65.0715 107.384C63.448 106.755 61.7495 106.165 60.0332 105.633C19.1286 92.9502 -24.2934 115.891 -37.0102 156.904C-49.7269 197.917 -26.9007 241.4 14.0039 254.083L273.791 334.634C314.695 347.317 358.118 324.376 370.834 283.363C383.551 242.35 360.725 198.868 319.82 186.185Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.028 74.0781C182.839 69.7697 175.889 66.2946 168.338 63.9531C128.864 51.7134 86.9414 73.8621 74.6693 113.441C73.8867 115.965 73.2363 118.467 72.7754 120.965C71.2091 120.353 69.5678 119.782 67.9087 119.267C28.4344 107.027 -13.4878 129.176 -25.7599 168.755C-29.7794 181.719 -30.1352 195.001 -27.3258 207.378C-20.0585 174.232 3.99884 114.038 80.7688 139.476C86.513 118.119 110.796 53.1532 189.028 74.0781Z",
    fill: "#4C4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8169 265.187L273.791 334.634C314.695 347.317 358.118 324.376 370.834 283.363C373.555 274.587 374.608 265.734 374.28 257.081C295.787 338.122 133.846 278.541 49.8169 265.187Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/cloud2.5a8bdb1d56e3fb41f11771bf3d665b5f.svg";
export { ForwardRef as ReactComponent };